/* family-swap.js v2.0 — Andrea Nicole gallery filter: "show only what the selection needs".
 * Upgrades v1.2 (hero-only) to a full per-variant thumbnail filter. Reads machine tags from
 * image alt text (written by tag_gallery.py):
 *   an:role=art                                            -> ALWAYS shown (the artwork; magnifier)
 *   an:family=print;role=mount                             -> shown only when Mounted is selected
 *   an:family=<print|canvas>;role=sizeref;size=A2;finish=white -> shown only if family+size+finish match
 *   an:family=print;role=hero;finish=white                 -> in-situ; family match + colour match (framed)
 *   an:family=canvas;role=hero                             -> canvas in-situ; any canvas finish
 * RULES: art=always · mount=when Mounted · sizeref=exact family+size+finish · hero=family (+colour if framed).
 * Unframed/Mounted have no frame colour -> all print heroes show. GRACEFUL DEGRADE: images with no
 * an: tag are never touched. Coexists with dependent-options.js (the framing-by-size picker).
 */
(function () {
  'use strict';
  if (window.__anGalleryFilterLoaded) return;
  window.__anGalleryFilterLoaded = true;

  function parseTag(alt) {
    if (!alt) return null;
    var m = alt.match(/an:([a-z0-9=;_-]+)/i);
    if (!m) return null;
    var out = {};
    m[1].split(';').forEach(function (kv) {
      var p = kv.split('=');
      if (p[0] && p[1]) out[p[0].trim().toLowerCase()] = p[1].trim().toLowerCase();
    });
    return out;
  }

  // Framing option value (lower-cased) -> selection context.
  var FINISH = {
    'unframed':               { family: 'print',  colour: null,      mount: false },
    'mounted':                { family: 'print',  colour: null,      mount: true  },
    'white frame':            { family: 'print',  colour: 'white'   },
    'black frame':            { family: 'print',  colour: 'black'   },
    'natural frame':          { family: 'print',  colour: 'natural' },
    'canvas + tray (black)':  { family: 'canvas', colour: 'black'   },
    'canvas + tray (white)':  { family: 'canvas', colour: 'white'   }
  };

  function selection() {
    var size = null, framing = null;
    var els = document.querySelectorAll(
      'variant-selects input:checked, variant-radios input:checked, variant-selects select, variant-radios select'
    );
    for (var i = 0; i < els.length; i++) {
      var el = els[i], val = el.value || '';
      var fs = el.closest('fieldset'), lg = fs && fs.querySelector('legend');
      var name = lg ? lg.textContent.trim().toLowerCase() : (el.name || '').toLowerCase();
      if (name.indexOf('size') === 0) size = val;
      else if (name.indexOf('fram') === 0) framing = val;
    }
    return {
      sizeLetter: size ? size.split(/\s+/)[0].toLowerCase() : null,
      ctx: FINISH[(framing || '').trim().toLowerCase()] || null
    };
  }

  function shouldShow(tag, sel) {
    if (!tag || !tag.role) return null;   // untagged -> leave alone (graceful degrade)
    if (!sel.ctx) return null;            // unknown finish -> leave alone
    var c = sel.ctx, role = tag.role;
    if (role === 'mount') return c.mount === true;
    // Mounted shows ONLY the mount shots (they already show the artwork) — hide art + heroes.
    if (c.mount) return false;
    if (role === 'art') return true;
    if (role === 'sizeref')
      return tag.family === c.family && tag.size === sel.sizeLetter && tag.finish === c.colour;
    if (role === 'hero') {
      if (tag.family !== c.family) return false;
      if (c.colour && tag.finish) return tag.finish === c.colour;
      return true;
    }
    return null;
  }

  function apply() {
    var sel = selection();
    var imgs = document.querySelectorAll(
      'media-gallery .product__media-item img, media-gallery .thumbnail-list__item img'
    );
    imgs.forEach(function (img) {
      var verdict = shouldShow(parseTag(img.getAttribute('alt')), sel);
      if (verdict === null) return;
      var li = img.closest('li');
      if (li) li.style.display = verdict ? '' : 'none';
    });
  }

  var observed = null;
  function observeGallery() {
    var mg = document.querySelector('media-gallery');
    if (mg && mg !== observed && window.MutationObserver) {
      observed = mg;
      new MutationObserver(function () { apply(); }).observe(mg, { childList: true, subtree: true });
    }
  }

  function init() {
    apply();
    observeGallery();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(apply, 50);
      }
    });
    document.addEventListener('shopify:section:load', function () { observeGallery(); setTimeout(apply, 50); });
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(apply, 50); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
